export default "__VITE_ASSET__73e31074__"